import { render, staticRenderFns } from "./pullnew-detail.vue?vue&type=template&id=a8045c40&scoped=true"
import script from "./pullnew-detail.vue?vue&type=script&lang=js"
export * from "./pullnew-detail.vue?vue&type=script&lang=js"
import style0 from "./pullnew-detail.vue?vue&type=style&index=0&id=a8045c40&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a8045c40",
  null
  
)

export default component.exports